module.exports = __webpack_public_path__ + "static/assets/d20b50c259b41f199f355ba77e795498.png";